import { forwardRef, useImperativeHandle } from "react";
import Collapse from "@/components/specific/Collapsable";
import { useNavigate } from "react-router-dom";

const AccountFAQ = forwardRef((props, ref) => {
  const navigate = useNavigate();
  const faqItems = [
    {
      key: "1",
      header: "How do I change my password?",
      content: `To change your password:
        1. Go to Settings
        2. Click on "General Settings"
        3. Select "Change Password"
        4. Enter your current password and new password
        5. Click "Update Password"`,
    },
    {
      key: "2",
      header: "How do I update my profile information?",
      content: `You can update your profile information in the "Manage Account" section
        under General Settings. Here you can modify your name, contact details,
        and other personal information.`,
    },
    // Add more FAQ items as needed
  ];

  // Expose handleContactSupport to parent
  useImperativeHandle(ref, () => ({
    handleContactSupport: async () => {
      // Handle contact support logic
      navigate("/dashboard/settings/support");
    },
  }));

  return (
    <div className="mt-10">
      <Collapse items={faqItems} />
    </div>
  );
});

AccountFAQ.displayName = "AccountFAQ";

export default AccountFAQ;
